import ActivitiesIndex from '@/views/ActivitiesIndex.vue';
import DevicesReport from '@/views/DevicesReport.vue';

const routes = [
    {
        path: '/activities',
        name: 'ActivitiesIndex',
        component: ActivitiesIndex,
        meta: { layout: 'DashboardLayout' }
    },
    {
        path: '/activities/report',
        name: 'DevicesReport',
        component: DevicesReport,
        meta: { layout: 'DashboardLayout' }
    }
];

export default routes
